module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.type === 'outline' || _vm.type === 'fill' || _vm.type === 'blank') ? _c('div', {
    class: {
      'rt-tag-outline': true,
      'is-disabled': _vm.disabled
    },
    style: ({
      borderRadius: _vm.radius + 'px',
      minHeight: _vm.tagSize + 'px',
      fontSize: _vm.tagSize === 'small' ? '12px' : '',
      border: _vm.type === 'fill' ? 'none' : '',
      backgroundColor: _vm.type === 'blank' ? _vm.SCSS_VARIABLES.COLOR_TEXT_WHITE : ''
    })
  }, [_c('span', {
    staticClass: "tag-text",
    class: [_vm.textType ? 'is-primary' : ''],
    style: ({
      WebkitLineClamp: _vm.line,
      maxWidth: _vm.maxWidth + 'px'
    }),
    on: {
      "click": _vm.onClick
    }
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.closable && !_vm.disabled) ? _c('rt-icon', {
    staticClass: "tag-close",
    attrs: {
      "color": _vm.SCSS_VARIABLES.COLOR_INFO,
      "name": _vm.closeChange ? 'rt-base-close_fill' : 'rt-base-close-x',
      "size": _vm.closeIconSize
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.close.apply(null, arguments)
      }
    },
    nativeOn: {
      "mouseover": function($event) {
        _vm.closeChange = true
      },
      "mouseleave": function($event) {
        _vm.closeChange = false
      }
    }
  }) : _vm._e()], 1) : _c('div', {
    class: _vm.classes,
    style: ({
      '--opacitie': _vm.borderOpacity,
      borderRadius: _vm.radius + 'px',
      minHeight: _vm.tagSize + 'px',
      paddingLeft: _vm.tagPadding + 'px',
      paddingRight: _vm.tagPadding + 'px',
      maxWidth: _vm.maxWidth + 'px'
    })
  }, [(_vm.isDot) ? _c('div', {
    staticClass: "is-dot"
  }) : _vm._e(), _vm._v(" "), _vm._t("icon-left", function() {
    return [(_vm.icon && _vm.iconDirection === 'left') ? _c('div', {
      staticClass: "__icon-left"
    }, [_c('rt-icon', {
      attrs: {
        "name": _vm.icon,
        "img-src": _vm.iconSrc,
        "color": _vm.iconColor
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.close.apply(null, arguments)
        }
      }
    })], 1) : _vm._e()]
  }), _vm._v(" "), _c('span', {
    staticClass: "rt-tag-text",
    class: {
      'dot-text': _vm.isDot
    },
    style: ({
      WebkitLineClamp: _vm.line
    })
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("icon-right", function() {
    return [(_vm.icon && _vm.iconDirection === 'right') ? _c('div', {
      staticClass: "__icon-right"
    }, [_c('rt-icon', {
      attrs: {
        "name": _vm.icon,
        "img-src": _vm.iconSrc,
        "color": _vm.iconColor
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.close.apply(null, arguments)
        }
      }
    })], 1) : _vm._e()]
  }), _vm._v(" "), (_vm.closable && !_vm.disabled) ? _c('rt-icon', {
    staticClass: "tag-close",
    attrs: {
      "color": _vm.closableIconColor,
      "name": _vm.closeChange ? 'rt-base-close_fill' : 'rt-base-close-x',
      "size": _vm.closeIconSize
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.close.apply(null, arguments)
      }
    },
    nativeOn: {
      "mouseover": function($event) {
        _vm.closeChange = true
      },
      "mouseleave": function($event) {
        _vm.closeChange = false
      }
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ce01a176"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/tag/rtTag.vue
// module id = 2158
// module chunks = 228